import { render, staticRenderFns } from "./publicity.vue?vue&type=template&id=b6397f6e&scoped=true&"
import script from "./publicity.vue?vue&type=script&lang=js&"
export * from "./publicity.vue?vue&type=script&lang=js&"
import style0 from "./publicity.vue?vue&type=style&index=0&id=b6397f6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6397f6e",
  null
  
)

export default component.exports